let mainScript = window.document.body.querySelector('script[data-main]');
let base = mainScript.dataset.base;
requirejs.config({baseUrl: base});

// 为Date类型提供简单的格式化支持
Date.format = function(date, fmt) {
	let o = {
		"M+": date.getMonth() + 1,
		"d+": date.getDate(),
		"h+": date.getHours(),
		"m+": date.getMinutes(),
		"s+": date.getSeconds(),
		"q+": Math.floor((date.getMonth() + 3) / 3),
		S: date.getMilliseconds()
	};
	if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (let k in o)
		if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
	return fmt;
};

Date.prototype.format = function (fmt) {
	return Date.format(this, fmt);
};



// 为Number提供格式化金额的方法
Number.formatMoney = function (value, sign) {
	let sstr = value >= 0 ? (sign ? '+' : '') : '-';
	let vstr = parseInt(Math.abs(value) * 100).toString();
	if (vstr == 'NaN')
		return '0.00';
	if (vstr.length == 1)
		return '0.0' + vstr;
	if (vstr.length == 2)
		return '0.' + vstr;
	let result = '.' + vstr.substr(-2);
	vstr = vstr.substr(0, vstr.length - 2);
	while (vstr.length > 3) {
		result = ',' + vstr.substr(-3) + result;
		vstr = vstr.substr(0, vstr.length - 3);
	}
	return sstr + vstr + result;
};



// JSON 插件，用于加载JSON文件
define('json', function (require, exports, module) {

	function json (name, callback) {
		let onErrorOccurred = callback.error || function (e) { throw e; };
		let xhr = new XMLHttpRequest();

		xhr.open('GET', require.toUrl(name + '.json'), true);
		xhr.onreadystatechange = function () {
			if (this.readyState != 4)
				return;
			try {
				if (this.status != 200)
					throw new Error('Faild to load json, HTTP status ' + this.status + '.');
				let exportName = name.replace(/^(\w)|[\-_](\w)/g, function ($0, $1, $2) {return ($1 || $2).toUpperCase()});
				let object = JSON.parse(this.responseText), exports = {};
				Object.defineProperty(exports, '__esModule', {value: true});
				Object.defineProperty(exports, exportName, {value: object});
				Object.defineProperty(exports, 'default', {value: object});
				callback(exports);
			} catch (e) {
				onErrorOccurred(e);
			}
		}.bind(xhr);

		xhr.send();
	}

	json.load = function (name, require, onload, config) {
		if (config.isBuild)
			return onload(null)
		this(name, onload);
	}

	return json;

});



// 配置文件封装，用于存取localStorage和sessionStorage
define('preferences', function (require, exports, module) {

	const $attrs = Symbol();

	class Preferences {

		constructor (symbol, key, type) {
			if (symbol !== $attrs)
				throw new Error('Use Preferences.load(key, type) instead.');
			let attrs = this[$attrs] = {key: key};
			switch (type) {
			case 'session':
				attrs.storage = sessionStorage;
				break;
			case 'local':
				attrs.storage = localStorage;
				break;
			default:
				throw new Error('Unknown storage type: ' + type);
				break;
			}
			this.load();
		}

		load () {
			let attrs = this[$attrs],
				json = attrs.storage.getItem(attrs.key) || '{}';
			attrs.data = JSON.parse(json);
			return this;
		}

		put (key, value) {
			this[$attrs].data[key] = value;
			return this;
		}

		get (key) {
			return this[$attrs].data[key];
		}

		clear () {
			this[$attrs].data = {};
			return this;
		}

		get raw () {
			return this[$attrs].data;
		}

		commit () {
			let attrs = this[$attrs],
				json = JSON.stringify(attrs.data)
			attrs.storage.setItem(attrs.key, json);
		}

	}

	const objkeys = {}, objects = new WeakMap();

	Object.defineProperty(Preferences, 'load', {value: function (key, type) {
		let objkey = objkeys[key];
		if (!objkey)
			objkey = objkeys[key] = new Object();

		let object = objects.get(objkey);
		if (object)
			return object;

		object = new Preferences($attrs, key, type);
		objects.set(objkey, object);
		return object;
	}});

	Object.defineProperty(exports, '__esModule', {value: true});
	Object.defineProperty(exports, 'Preferences', {value: Preferences});
	Object.defineProperty(exports, 'default', {value: Preferences});
});



// 一个轻量级的Simpledown格式转html的转换器
define('simpledown', function (require, exports, module) {

	class Simpledown {

		constructor () {
			throw new Error('This class can not be instantiated');
		}

	}

	Simpledown.toHTML = function (content, baseuri) {
		if (!content)
			return content;

		let lines = content.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
			.replace(/\r/g, '').split('\n');

		let result = '<p>';
		baseuri = baseuri || '';

		for (let i = 0, prev = true; i < lines.length; ++i) {
			let line = lines[i].replace(/\s{2,}/g, function (matched) {
				let nbsps = '';
				for (let i = 0; i < matched.length; ++i)
					nbsps += '&nbsp;';
				return nbsps;
			});

			if (line.trim()) {
				if (!prev)
					result += '<br>';
				prev = false;
				result += line.replace(/\[(h[1-6])(#[0-9A-Fa-f]{6})?\[(.+?)\]\]/g, function (raw, tagName, color, text) {
					return '</p><' + tagName + (color ? ' style="color:' + color + '">' : '>') +
						text + '</' + tagName + '><p>';
				}).replace(/\[(del|em|ins|mark|span|strong|sub|sup)(#[0-9A-Fa-f]{6})?\[(.+?)\]\]/g, function (raw, tagName, color, text) {
					return '<' + tagName + (color ? ' style="color:' + color + '">' : '>') +
						text + '</' + tagName + '>';
				}).replace(/\[image\((.+?)\)\]/g, function (raw, uri) {
					if (!uri.match(/^https?:/))
						uri = baseuri + uri;
					return '</p><p><img src="' + uri + '"></img></p><p>';
				}).replace(/\[(audio|video)\((.+?)\)\]/g, function (raw, tagName, uri) {
					if (!uri.match(/^https?:/))
						uri = baseuri + uri;
					return '</p><p><' + tagName + ' src="' + uri + '" controls="controls"></' + tagName + '></p><p>';
				}).replace(/\[link\[(.+?)\]\((.+?)\)\]/g, function (raw, text, uri) {
					if (!uri.match(/^(https?|tel|mailto|geo):/))
						uri = baseuri + uri;
					let target = (uri.match(/^(tel|mailto|geo):/)) ? '_self' : '_blank';
					return '<a href="' + uri + '" target="' + target + '">' + text + '</a>';
				});
			} else {
				if (!prev)
					result += '</p><p>';
				prev = true;
			}
		}

		return (result += '</p>').replace(/(<br>)?(<\/?p>)(<br>)?/g, (raw, br1, tag, br2) => tag)
			.replace(/<p><\/p>/g, '');
	}

	Object.defineProperty(exports, '__esModule', {value: true});
	Object.defineProperty(exports, 'Simpledown', {value: Simpledown});
	Object.defineProperty(exports, 'default', {value: Simpledown});

});



// artTemplate 包装
define('template', function (require, exports, module) {

	const Template = require('libs/art-template/lib/template-web');

	Template.defaults.imports.formatDate = function (date, fmt) {
		return new Date(date).format(fmt);
	};

	Template.defaults.imports.formatMoney = function (value, sign) {
		return Number.formatMoney(value, sign);
	};

	Object.defineProperty(exports, '__esModule', {value: true});
	Object.defineProperty(exports, 'Template', {value: Template});
	Object.defineProperty(exports, 'default', {value: Template});

});



// Hash插件，包含各种常用的Hash算法
define('hashes', function (require, exports, module) {

const Hashes = require('libs/jshashes/hashes.min.js');

Object.defineProperty(Hashes, '__esModule', {value: true});
Object.defineProperty(Hashes, 'Hashes', {value: Hashes});
Object.defineProperty(Hashes, 'default', {value: Hashes});

return Hashes;

});



// Api 请求代理
define ('api-agent', function (require, exports, module) {

	const Preferences = require('preferences').default;

	class ApiAgent {

		constructor (listener) {
			this.prefs = Preferences.load('/backend/authorization', 'session');
			this.sequence = 1;
			this.tasks = [];
			this.listener = listener;
		}

		sendApiRequest (request) {
			let sequence = this.sequence++;
			this.startAjaxForApiRequest(request, sequence);
			return sequence;
		}

		startAjaxForApiRequest (request, sequence) {
			let ajaxConfig = {
				cache : request.cache,
				contentType : 'application/json',
				context : {
					sequence : sequence,
					agent : this,
					request : request,
				},
				data : request.data,
				headers : request.headers || {},
				timeout : request.timeout,
				type : request.type,
				url : request.url,
				complete : this.onAjaxComplete,
			};

			let token = this.getToken();
			if (token)
				ajaxConfig.headers['Authorization'] = token;
			ajaxConfig.headers['Accept'] = 'application/json';

			this.tasks[sequence] = $.ajax(ajaxConfig);
		}

		setToken (token) {
			this.prefs.load().put('token', token).commit();
		}

		getToken () {
			return this.prefs.load().get('token');
		}

		getDate () {
			let timediff = this.prefs.get('timediff');
			if (Object.isUndefined(timediff))
				return undefined;
			if (timediff == 0)
				return new Date();
			return new Date(new Date().getTime() + timediff);
		}

		onAjaxComplete (xhr, status) {
			let agent = this.agent, request = this.request, sequence = this.sequence, data;
			delete agent.tasks[sequence];

			try {
				let datestr = xhr.getResponseHeader('Date');
				if (datestr) {
					let localTime = parseInt(new Date().getTime() / 1000) * 1000;
					let serverTime = new Date(datestr).getTime();
					agent.prefs.load().put('timediff', serverTime - localTime).commit();
				}
			} catch (e) {
				// Do nothing.
			}

			try {
				data = JSON.parse(xhr.responseText);
			} catch (e) {
				data = null;
			}

			if (xhr.status == 401)
				agent.setToken(undefined);

			let listener = agent.listener || agent;
			listener.onApiResponse(request, xhr.status, data);
		}

		abortApiRequest (sequence) {
			let ajax = this.tasks[sequence];
			if (!ajax)
				return;
			ajax.abort();
		}

	}

	Object.defineProperty(exports, '__esModule', {value: true});
	Object.defineProperty(exports, 'ApiAgent', {value: ApiAgent});
	Object.defineProperty(exports, 'default', {value: ApiAgent});

});



// Periodical task.
define('staple/periodical-task', function (require, exports, module) {

const $attrs = Symbol();

class PeriodicalTask {

	constructor (ms, repeat, runnable) {
		this[$attrs] = {
			runnable: runnable,
			ms: ms,
			repeat: repeat,
		};
	}

	handler () {
		let attrs = this[$attrs];
		if (!attrs.repeat)
			delete attrs.tid;
		let runnable = attrs.runnable || this;
		runnable.run();
	}

	start (restart) {
		let attrs = this[$attrs];
		if (attrs.tid) {
			if (!restart)
				return;
			let stopFunc = attrs.repeat ? clearInterval : clearTimeout;
			stopFunc(attrs.tid);
		}
		let startFunc = attrs.repeat ? setInterval : setTimeout;
		attrs.tid = startFunc(this.handler.bind(this), attrs.ms);
	}

	stop () {
		let attrs = this[$attrs];
		if (!attrs.tid)
			return;
		let stopFunc = attrs.repeat ? clearInterval : clearTimeout;
		stopFunc(attrs.tid);
		delete attrs.tid;
	}

	get running () {
		return this[$attrs].tid ? true : false;
	}

}

Object.defineProperty(exports, '__esModule', {value: true});
Object.defineProperty(exports, 'PeriodicalTask', {value: PeriodicalTask});
Object.defineProperty(exports, 'default', {value: PeriodicalTask});

});



// HTML parser.
define('staple/html-parser', function (require, exports, module) {

	const factroy = window.document.createElement('div');

	class HTMLParser {

		constructor () {
			throw new Error('This class can not be instantiated');
		}

	}

	HTMLParser.parse = function (html) {
		factroy.innerHTML = html;
		let children = factroy.children, result = [];
		for (let i = 0, child; child = children[i]; ++i)
			result.push(child);
		for (let i = 0, child; child = children[i]; ++i)
			factroy.removeChild(child);
		return result;
	}

	Object.defineProperty(exports, '__esModule', {value: true});
	Object.defineProperty(exports, 'HTMLParser', {value: HTMLParser});
	Object.defineProperty(exports, 'default', {value: HTMLParser});

});



// A module usd to load specified NLS(Native Language Support) bundle.
define('staple/nls', function (require, exports, module) {

	class NLSBundleLoader {

		constructor (bundle, languages, require, onload) {
			this.bundle = bundle;
			this.languages = languages;
			this.require = require;
			this.onload = onload;
		}

		load () {
			// Load master of NLS bundle.
			require([this.bundle + '/master'], this.onMasterLoaded.bind(this));
		}

		onMasterLoaded (master) {
			let parts = this.parts = [], needed = this.needed = [],
				names = [];
			let languages = this.languages;

			this.master = master = master.default;

			// Checkout which stand-alone NLS parts need to load.
			for (let i = languages.length - 1; i >= 0; --i) {
				let language = languages[i];
				if (!language)
					continue;
				language = language.toLowerCase();
				let value = master[language];
				if (!value)
					continue;
				parts.push(language);
				if (typeof value === 'object')
					continue;
				needed.push(language);
				names.push(this.bundle + '/' + language);
			}

			// Load needed stand-alone NLS parts
			this.require(names, this.onPartsLoaded.bind(this));
		}

		onPartsLoaded () {
			let master = this.master, needed = this.needed, parts = this.parts,
				values = {};

			// Add add stand-along NLS part to master.
			for (let i = 0; i < needed.length; ++i)
				master[needed[i]] = arguments[i].default;

			// Mixin all locale parts into a bundle.
			let bundle = {'@name' : this.bundle};
			for (let i = 0, source; source = master[parts[i]]; ++i)
				for (let prop in source)
					bundle[prop] = source[prop];

			// Create exports
			let exports = {};
			for (let prop in bundle)
				Object.defineProperty(exports, prop, {value: bundle[prop]});

			// Notify bundle loaded.
			Object.defineProperty(exports, '__esModule', {value: true});
			Object.defineProperty(exports, 'default', {value: exports});
			this.onload(exports);
		}

	}

	function load (name, require, onload, config) {
		if (config.isBuild)
			return onload(null)

		let languages = [];

		// Customized languages
		if (navigator.customizedLanguage)
			languages.push(navigator.customizedLanguage);

		// Browser languages
		if (navigator.language)
			languages.push(navigator.language);
		if (navigator.languages)
			languages = languages.concat(navigator.languages);

		// Default language
		languages.push('root');

		// Deduplicate
		let unique = [], map = {};
		for (let i = 0, lang; lang = languages[i]; ++i) {
			if (map[lang])
				continue;
			map[lang] = true;
			unique.push(lang);
		}
		languages = unique;

		// Load bundle.
		let loader = new NLSBundleLoader(name, languages, require, onload);
		loader.load();
	}

	exports.load = load;

});



// A module usd to load HTML snippets from an snippets file.
define('staple/snippets', function (require, exports, module) {

	const HTMLParser = require('staple/html-parser').default;
	const [loadersMap, snippetsMap] = [{}, {}];

	class SnippetsLoader {

		constructor (path, require, onload) {
			this.path = path;
			this.require = require;
			this.onload = onload;
		}

		notifyError (text) {
			let error = new Error('Faild to load snippet file: ' + this.path + '(' + text + ').');
			this.onload.error(error);
		}

		load () {
			let xhr = new XMLHttpRequest();
			xhr.open('get', this.require.toUrl(this.path + '.html'), true);
			xhr.onreadystatechange = evt => {
				if (xhr.readyState != 4)
					return;
				if (xhr.status != 200)
					return this.onHTMLNotLoaded(xhr);
				this.onHTMLLoaded(xhr);
			};
			xhr.send();
		}

		onHTMLLoaded (xhr) {
			let html = this.html = xhr.responseText;

			// Find all NLS placeholders.
			let matches = html.match(/\[nls\@[a-zA-Z0-9\-\/_]+:[a-zA-Z0-9\-_]+\]/g);

			// No NLS placeholders, mark ready and return.
			if (!matches || !matches.length)
				return this.onNLSResolved();

			// Prepare to load NLS bundles.
			let nlsphs = this.nlsphs = [], names = [], namemap = {};
			for (let i = 0, match; match = matches[i]; ++i) {
				let pair = match.substr(5, match.length - 6).split(':');
				nlsphs.push({
					match : match,
					name : pair[0],
					key : pair[1],
				});
				if (namemap[pair[0]])
					continue;
				namemap[pair[0]] = true;
				names.push('staple/nls!' + pair[0]);
			}

			// Load NLS Bundles
			this.require(names, this.onNLSLoaded.bind(this));
		}

		onHTMLNotLoaded (xhr) {
			this.notifyError(xhr.status);
		}

		onNLSLoaded () {
			let nlsphs = this.nlsphs, html = this.html;

			// Build a lookup map for loaded NLS bundles.
			let bundles = {};
			for (let i = 0, bundle; bundle = arguments[i]; ++i)
				bundles[bundle.default['@name']] = bundle.default;

			// Replace all NLS placeholders with NLS strings.
			for (let i = 0, nlsph; nlsph = nlsphs[i]; ++i)
				html = html.replace(nlsph.match, bundles[nlsph.name][nlsph.key]);

			this.html = html;
			this.onNLSResolved();
		}

		onNLSResolved () {
			let html = this.html, head = window.document.head, snippets = {};

			for (let i = 0, els = HTMLParser.parse(html), el; el = els[i]; ++i) {
				switch (el.tagName.toLowerCase()) {
				case 'style':
					head.appendChild(el);
					break;
				case 'script':
					if (el.type !== 'text/html' || !el.id)
						break;
					Object.defineProperty(snippets, el.id, {value: el.innerHTML.trim()});
					break;
				default:
					break;
				}
			}

			Object.defineProperty(snippets, '__esModule', {value: true});
			Object.defineProperty(snippets, 'default', {value: snippets});
			this.onload(snippets);
		}

	}

	function load (name, require, onload, config) {
		if (config.isBuild)
			return onload(null);

		let loader = new SnippetsLoader(name, require, onload);
		loader.load();
	};

	exports.load = load;

});



// UUID generator.
define('staple/uuid', function (require, exports, module) {

	const CHARS = "0123456789ABCDEF".split("");

	class UUID {

		constructor () {
			throw new Error('This class can not be instantiated');
		}

	}

	UUID.randomUUID = function () {
		let chars = CHARS, uuid = new Array(36), rnd=0, r;
		for (let i = 0; i < 36; i++) {
			if (i==8 || i==13 || i==18 || i==23) {
				uuid[i] = "-";
			} else if (i==14) {
				uuid[i] = "4";
			} else {
				if (rnd <= 0x02) rnd = 0x2000000 + (Math.random()*0x1000000)|0;
				r = rnd & 0xf;
				rnd = rnd >> 4;
				uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
			}
		}
		return uuid.join("");
	};

	Object.defineProperty(exports, '__esModule', {value: true});
	Object.defineProperty(exports, 'UUID', {value: UUID});
	Object.defineProperty(exports, 'default', {value: UUID});

});



// 地图API加载器，用来加载地图API，经过测试可正确加载的有百度地图和腾讯地图
// 需要配置相关的json文件才能正确加载
define('maps', function() {

	class MapApiLoader {

		constructor (name, require, onload) {
			this.name = name;
			this.require = require;
			this.onload = onload;
		}

		load () {
			this.require(['json!' + this.name], this.onConfigLoaded.bind(this));
		}

		onConfigLoaded (config) {
			config = config.default;
			this.callback = '__maps_' + this.name + '_callback__';
			window[this.callback] = this.onApiLoaded.bind(this, config);

			let script = document.createElement('script');
			script.type = 'text/javascript';
			script.async = true;
			let url = config.url;
			script.src = config.url + ((config.url.indexOf('?') < 0) ? '?' : '&') + 'callback=' + this.callback;
			let first = document.getElementsByTagName('script')[0];
			first.parentNode.insertBefore(script,first);
		}

		onApiLoaded (config) {
			let exports = {};
			Object.defineProperty(exports, '__esModule', {value: true});
			for (let exp of config.exports) {
				let match = exp.match(/^\s*([0-9a-zA-Z_\.\$]+)(\s+as\s+([0-9a-zA-Z_\$]+))?\s*$/);
				if (!match)
					this.require.error(new Error('Invalid export: ' + exp));
				let origin = match[1];
				let alias = match[3] || origin;
				if (!/^[0-9a-zA-Z_\$]+$/.test(alias))
					this.require.error(new Error('Alias is required for ' + exp));

				let nodes = origin.split('.');
				let value = window;
				for (let node of nodes)
					value = value[node];

				Object.defineProperty(exports, alias, {value: value});
			}

			this.onload(exports);
		}

	}

	return{
		load : function(name, require, onload, config){
			if(config.isBuild)
				return onLoad(null);
			let loader = new MapApiLoader(name, require, onload);
			loader.load();
		}
	};

});


// ECharts 封装
define('echarts', function (require, exports, module) {

	const ECharts = require('libs/echarts/dist/echarts.min.js');

	Object.defineProperty(exports, '__esModule', {value: true});
	Object.defineProperty(exports, 'ECharts', {value: ECharts});
	Object.defineProperty(exports, 'default', {value: ECharts});

});


// 页面主文件加载器，加载页面主文件并创建全局单例
define(function (require, exports, module) {

	// 解析Query参数并存放的location.args中，方便后续访问
	if (location.search) {
		let fields = location.search.substr(1).split('&');
		let args = {};

		for (let i = 0, field; field = fields[i]; ++i) {
			let kv = field.split('=');
			args[kv[0]] = decodeURIComponent(kv[1]);
		}

		location.args = args;
	} else {
		location.args = [];
	}

	function loader (name, callback) {
		// 检查浏览器是否支持所需的特性
		if (!localStorage)
			return alert('抱歉，您的浏览器旧了一点\n我们需要Chrome、Firefox或至少IE8以上的浏览器');
		try {
			localStorage.setItem('#@!~', '~!@#');
			if ('~!@#' !== localStorage.getItem('#@!~'))
				throw new Error('Storage test failed.');
			localStorage.removeItem('#@!~');
		} catch (e) {
			return alert('您正处于无痕浏览模式，请切换至正常模式再打开');
		}

		// Load page class and init.
		require(['js/' + name, 'libs/requirejs-domready/domReady!'], function (module) {
			let Class = module.default;
			let instance = window.instance = new Class();
			instance.onLoad();
			callback(instance);
		});
	}

	loader.load = function (name, require, onload, config) {
		if (config.isBuild)
			return onload(null)
		loader(name, onload);
	}

	return loader;

});
